// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseLearnerDetailsPopover_root__dVcuH","detail":"CoursePauseLearnerDetailsPopover_detail__w-iGu","closeIcon":"CoursePauseLearnerDetailsPopover_closeIcon__w63k4"};